import { CounterMedium } from "../../../Devices/CounterMedium";
import { IAutomationObject } from "../../../types";

export interface IPortfolioEnergyChart extends IAutomationObject {
    numItems: number,
    byM2: boolean,
    timeRange: TimeRange,
    counterMediumFilter?: CounterMedium
}

export enum TimeRange {
    Last30Days,
    Last12Months,
    YearToDate
}

export const schema = 'AutomationApps.ReportsAndStatistics.Portfolio.PortfolioEnergyChart';